<template>
  <div>
    <v-list-item
      v-if="!menuItem.items"
      :input-value="menuItem.value"
      :exact="menuItem.exact"
      :disabled="menuItem.disabled"
      :to="menuItem.text !== 'Documentación Api' ? menuItem.link : undefined"
      :href="menuItem.text === 'Documentación Api' ? menuItem.link : undefined"
      :target="menuItem.text === 'Documentación Api' ? '_blank' : undefined"
      active-class="primary--text"
      link
    >
      <v-list-item-icon>
        <v-icon
          :small="small"
          :class="{ 'grey--text': menuItem.disabled }"
        >
          {{ menuItem.icon }}
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          <v-chip
            v-if="menuItem.chip"
            class="mr-1 font-weight-black"
            dark
            dense
            label
            :color="menuItem.color"
            x-small
          >
            {{ menuItem.api }}
          </v-chip>
          {{ menuItem.key ? $t(menuItem.key) : menuItem.text }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-group
      v-else
      :value="menuItem.regex ? menuItem.regex.test($route.path) : false"
      :disabled="menuItem.disabled"
      :sub-group="subgroup"
      :to="menuItem.link"
      link
    >

      <template #activator>
        <v-list-item-icon v-if="!subgroup">
          <v-icon :small="small">{{ menuItem.icon || 'mdi-circle-medium' }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ menuItem.key ? $t(menuItem.key) : menuItem.text }}
          </v-list-item-title>
        </v-list-item-content>
      </template>

      <slot />

    </v-list-group>
  </div>
</template>

<script>
/*
|---------------------------------------------------------------------
| Navigation Menu Item Component
|---------------------------------------------------------------------
|
| Navigation items for the NavMenu component
|
*/
export default {
  props: {
    menuItem: {
      type: Object,
      default: () => {}
    },
    subgroup: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>
